import { List } from "immutable";
import * as signalR from "@aspnet/signalr";
import { TreeBranch, NavItem } from "../models/navigation";

export interface NavigationState {
    branches: List<TreeBranch | undefined>;

    /**
     * Used for dynamic pages that need to have a navigation item marked as active
     */
    childOfPath?: string;

    currentPath: string;
    hasStorageNav: boolean;
    initialized: boolean;
    loading: boolean;
    tree: TreeBranch;
    mainNav: NavItem[];
    pathHistory: List<string>;
    secondaryNav?: NavItem;
    websocket?: signalR.HubConnection;
}

// initialize root object
const root: TreeBranch = {
    active: false,
    childIds: [],
    id: 0,
    level: 0,
    onNav: true,
    parentIds: [],
    recordId: 0,
    separator: false,
    sort: 0,
    title: "Home",
    typeId: 0,
    url: "/",
};

export const initialState: NavigationState = {
    branches: List([root]),
    currentPath: "/",
    hasStorageNav: false,
    initialized: false,
    loading: true,
    pathHistory: List(),
    tree: root,
    mainNav: [],
};



// WEBPACK FOOTER //
// ./src/store/NavigationState.ts